import Vue from 'vue'
import Router from 'vue-router'

const home = () => import('@/components/home')
const Recharge = () => import('@/components/Recharge')
const recharge1 = () => import('@/components/recharge/index')
const pay = () => import('@/components/recharge/pay')

const news = () => import('@/components/news')
const detail = () => import('@/components/news/detail')
const newsList = () => import('@/components/news/list')
const allNews = () => import('@/components/news/list/allNews')
const afficheNews = () => import('@/components/news/list/afficheNews')
const activityNews = () => import('@/components/news/list/activityNews')
const gameNews = () => import('@/components/news/list/gameNews')
const strategy = () => import('@/components/news/list/strategy')

const retrievePassword = () => import('@/components/retrievePassword')
const retrievePasswordMessage = () => import('@/components/retrievePassword/retrievePasswordMessage')
const changePassword = () => import('@/components/retrievePassword/retrievePasswordMessage/changePassword')
const retrievePasswordMpho = () => import('@/components/retrievePassword/retrievePasswordMessage/retrievePasswordMpho')
const retrievePasswordMemail = () => import('@/components/retrievePassword/retrievePasswordMessage/retrievePasswordMemail')
const retrievePasswordSucce = () => import('@/components/retrievePassword/retrievePasswordSucce')
const retrievePasswordPSucce = () => import('@/components/retrievePassword/retrievePasswordSucce/retrievePasswordPSucce')
const retrievePasswordESucce = () => import('@/components/retrievePassword/retrievePasswordSucce/retrievePasswordESucce')
const retrievePasswordEmSucce = () => import('@/components/retrievePassword/retrievePasswordSucce/retrievePasswordEmSucce')
const choose = () => import('@/components/retrievePassword/choose')

const personage = () => import('@/components/personage')
const modified = () => import('@/components/personage/modified')
const person = () => import('@/components/personage/person')
const mystery = () => import('@/components/personage/mystery')
const mystery2 = () => import('@/components/personage/mystery2')
const mystery3 = () => import('@/components/personage/mystery3')
const mysterySucce = () => import('@/components/personage/mysterySucce')
const record = () => import('@/components/personage/record')
const email = () => import('@/components/personage/email')
const email2 = () => import('@/components/personage/email2')
const bindMail = () => import('@/components/personage/email3')
const changemail = () => import('@/components/personage/changemail')
const newemail = () => import('@/components/personage/newemail')
const pho = () => import('@/components/personage/pho')
const phosucce = () => import('@/components/personage/phosucce')
const changepho = () => import('@/components/personage/changepho')
const changephoSucce = () => import('@/components/personage/changephoSucce')
const relievepho = () => import('@/components/personage/relievepho')
const relievephoSucce = () => import('@/components/personage/relievephoSucce')
const password = () => import('@/components/personage/password')
const custody = () => import('@/components/custody')

//落地页
const cwby = () => import('@/components/squeezepage/cwby')
const ztsg = () => import('@/components/squeezepage/ztsg')
const kingofrebirth = () => import('@/components/squeezepage/kingofrebirth')
const idlerancher = () => import('@/components/squeezepage/idlerancher')
const mystage = () => import('@/components/squeezepage/mystage')

//客服系统
const customerSystem = () => import('@/views/customerSystem/index')
const appeal = () => import('@/views/customerSystem/appealList')
const popup = () => import('@/views/customerSystem/popup')
const progress = () => import('@/views/customerSystem/progress')
const payProblem = () => import('@/views/customerSystem/center/pay')
const loginProblem = () => import('@/views/customerSystem/center/login')
const accountProblem = () => import('@/views/customerSystem/center/account')
const report = () => import('@/views/customerSystem/center/report')
const bug = () => import('@/views/customerSystem/center/bug')
const suggestion = () => import('@/views/customerSystem/center/suggestion')

//社区
const forum = () => import('@/views/forum/index')
const recommond = () => import('@/views/forum/recommond')
const topic = () => import('@/views/forum/topic')
const userCenter = () => import('@/views/forum/userCenter')
const otherUser = () => import('@/views/forum/otherUser')
const profile = () => import('@/views/forum/my/profile')
const myPost = () => import('@/views/forum/my/myPost')
const notifications = () => import('@/views/forum/my/notifications')
const myReply = () => import('@/views/forum/my/myReply')
const post = () => import('@/views/forum/post')
const search = () => import('@/views/forum/search')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      name: 'home',
      component: home
    },
    {
      path: '/recharge',
      component: Recharge,
      children:[
        {path: '',component: recharge1},
        {path: 'pay',component: pay}
      ]
    },

    {
      path:'/news',
      component: news,
      children:[
        {path:'detail',component:detail},
        {
          path:'newsList',
          component:newsList,
          children:[
            {path:'allNews',component:allNews},
            {path:'afficheNews',component:afficheNews},
            {path:'activityNews',component:activityNews},
            {path:'gameNews',component:gameNews},
            {path:'strategy',component:strategy},
          ]
        }
      ]
    },
    {
      path: '/retrievePassword',
      component: retrievePassword,
      children:[
        {path:'',component:choose},
        {
          path:'retrievePasswordMessage',
          component:retrievePasswordMessage,
          children:[
            {path:'retrievePasswordMemail',component:retrievePasswordMemail},
            {path:'retrievePasswordMpho',component:retrievePasswordMpho},
            {path:'changePassword',component:changePassword}
          ]
        },
        {
          path:'retrievePasswordSucce',
          component:retrievePasswordSucce,
          children:[
            {path:'retrievePasswordPSucce',component:retrievePasswordPSucce},
            {path:'retrievePasswordESucce',component:retrievePasswordESucce},
            {path:'retrievePasswordEmSucce',component:retrievePasswordEmSucce},
          ]
        }
      ]
    },
    {
      path: '/personage',
      component: personage,
      children:[
        {path:'',component:person},
        {path:'modified',component:modified},
        {path:'record',component:record},
        {path:'mystery',component:mystery},
        {path:'mystery2',component:mystery2},
        {path:'mystery3',component:mystery3},
        {path:'mysterySucce',component:mysterySucce},
        {path:'email',component:email},
        {path:'email2',component:email2},
        {path:'bindMail',component:bindMail},
        {path:'changemail',component:changemail},
        {path:'newemail',component:newemail},
        {path:'pho',component:pho},
        {path:'phosucce',component:phosucce},
        {path:'changepho',component:changepho},
        {path:'changephoSucce',component:changephoSucce},
        {path:'relievepho',component:relievepho},
        {path:'relievephoSucce',component:relievephoSucce}, 
        {path:'password',component:password}
      ]
    },
    {
      path: '/custody',
      name: 'custody',
      component: custody
    },
    {
      path: '/cwby',
      name: 'cwby',
      component: cwby
    },
    {
      path: '/ztsg',
      name: 'ztsg',
      component: ztsg
    },
    {
      path: '/kingofrebirth',
      name: 'kingofrebirth',
      component: kingofrebirth
    },
    {
      path: '/squeezepage/idlerancher',
      name: 'idlerancher',
      component: idlerancher
    },
    {
      path: '/mystage',
      name: 'mystage',
      component: mystage
    },

    //客服系统
    {path: '/customer',name: 'index', component: customerSystem},
    {path: '/customer/appeal',name: 'appeal', component: appeal},
    {path: '/customer/progress',name: 'progress', component: progress},
    {path: '/customer/pay',name: 'pay', component: payProblem},
    {path: '/customer/login',name: 'login', component: loginProblem},
    {path: '/customer/account',name: 'account', component: accountProblem},
    {path: '/customer/report',name: 'report', component: report},
    {path: '/customer/bug',name: 'bug', component: bug},
    {path: '/customer/suggestion',name: 'suggestion', component: suggestion},
    {path: '/customer/popup',name: 'popup', component: popup},
    
    //社区
    {
      path: '/forum',
      component: forum,
      children:[
        {
          path:'',
          name: 'forumHome',
          component: recommond,
          meta:{
            title:'社区首页',
            group: 'forum'
          }
        },
        {
          path:'search/:keyword',
          name: 'forumSearch',
          component: search,
          meta:{
            title:'搜索',
            group: 'forum'
          }
        },
        {
          path:'user/:id',
          name: 'userHome',
          component: otherUser,
          meta:{
            title:'个人主页',
            group: 'forum'
          }
        },
        {
          path:'userCenter',
          name: 'userCenter',
          component: userCenter,
          meta:{
            title:'个人中心',
            group: 'forum'
          },
          children:[
            {
              path:'profile',
              name: 'profile',
              component: profile,
              meta:{
                title:'个人资料',
                group: 'user'
              },
            },
            {
              path:'post',
              name: 'post',
              component: myPost,
              meta:{
                title:'我的帖子',
                group: 'user'
              },
            },
            {
              path:'notifications',
              name: 'notifications',
              component: notifications,
              meta:{
                title:'消息通知',
                group: 'user'
              },
            },
            {
              path:'reply',
              name: 'reply',
              component: myReply,
              meta:{
                title:'我的回复',
                group: 'user'
              },
            }
          ]
        },
        {
          path:'topic/:id',
          name: 'topic',
          component: topic,
          meta:{
            title:'',
            group: 'forum'
          }
        },
        {
          path:'post',
          name: 'post',
          component: post,
          meta:{
            title:'发帖子',
            group: 'forum'
          }
        }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js